export default __webpack_public_path__ + "static/media/outs.c9eb000b.svg";